import {
  getMemberCreditList,
  getMemberCreditListOwner,
} from '../../api/memberCreditApi';
import { MemberCreditData } from '../../dto/EntityRepository';
import { MemberCreditListResponse } from '../../dto/ResDtoRepository';
import { useMemberCreditStore } from '../../store/memberCreditStore';
import { usePageOwnerIdentityStore } from '../../store/pageOwnerIdentityStore';
import { useApiWrapper } from './apiWrapper';
import { runCurrentArchiveRequest } from '../../util/currentArchiveRequest';

interface UseMemberCreditResult {
  credits: MemberCreditData[];
  getMemberCreditList: () => Promise<void>;
  getMemberCreditListOwner: () => Promise<void>;
  clearCredits: () => void;
}

export const useMemberCredit = (): UseMemberCreditResult => {
  const pageOwner = usePageOwnerIdentityStore((s) => s.pageOwner);
  const { credits, setCredits, clearCredits } = useMemberCreditStore();
  const withApiHandler = useApiWrapper();

  const handleGetMemberCreditListSuccess = (
    response: MemberCreditListResponse,
  ) => {
    setCredits(response.data);
  };

  const handleMemberCreditRequest = async (
    action: 'get' | 'get_for_owner',
  ) => {
    if (!pageOwner) return;
    const { aui } = pageOwner;
    const apiFunction = async () => {
      switch (action) {
        case 'get_for_owner':
          return runCurrentArchiveRequest(
            aui,
            () => getMemberCreditListOwner(aui),
            handleGetMemberCreditListSuccess,
          );
        case 'get':
        default:
          return runCurrentArchiveRequest(
            aui,
            () => getMemberCreditList(aui),
            handleGetMemberCreditListSuccess,
          );
      }
    };

    await withApiHandler(apiFunction, [aui, action]);
  };

  const getMemberCreditListHandler = () =>
    handleMemberCreditRequest('get');
  const getMemberCreditListOwnerHandler = () =>
    handleMemberCreditRequest('get_for_owner');

  return {
    credits,
    getMemberCreditList: getMemberCreditListHandler,
    getMemberCreditListOwner: getMemberCreditListOwnerHandler,
    clearCredits,
  };
};
